import { RoutingStrategy } from '@api/generated/graphql';
import { serviceState } from '@modules/ServiceModule/workspace/lib/state';

/**
 * Returns true if the given queue exists and is ring all
 * (simultaneous ring) queue.
 *
 * @param queueId
 */
export default function isRingAllQueue(queueId: string) {
  const queue = serviceState.queueById[queueId];
  return queue ? queue.routingStrategy === RoutingStrategy.RingAll : false;
}
